import SectionLabel from "@/components/base/SectionLabel";
import { supportData } from "@/mocks/homeData";

export default function SupportSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16 reveal">
          <SectionLabel label={supportData.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {supportData.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {supportData.items.map((item, idx) => (
            <div
              key={item.title}
              className="reveal p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-5">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-primary-500 text-lg md:text-xl`} />
                </div>
                <div>
                  <span className="block text-[10px] md:text-xs font-medium tracking-wider text-primary-500 font-label mb-0.5">
                    {item.subtitle}
                  </span>
                  <h3 className="text-lg md:text-xl font-bold text-foreground-900 font-heading">
                    {item.title}
                  </h3>
                </div>
              </div>

              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4 md:mb-5">
                {item.intro}
              </p>

              <div className="bg-background-100 rounded-md p-3.5 md:p-4">
                <p className="text-xs md:text-sm font-medium text-foreground-600 mb-2 md:mb-2.5 font-label">
                  よくある課題
                </p>
                <ul className="space-y-1.5 md:space-y-2">
                  {item.problems.map((p) => (
                    <li
                      key={p}
                      className="flex items-start gap-2 text-sm text-foreground-700"
                    >
                      <span className="w-1 h-1 rounded-full bg-primary-500 mt-2 flex-shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}